import * as actionTimeslots from "./actionTimeslots";
import * as actionLocations from "./actionLocations";
import * as actionProviders from "./actionProviders";
import * as actionAppointment from "./actionAppointment";
import * as actionSelectedDate from "./actionSelectedDate";

import * as actionUser from "./actionUser";

export const ActionCreators = Object.assign(
  {},
  actionTimeslots,
  actionLocations,
  actionProviders,
  actionAppointment,
  actionSelectedDate,
  actionUser
);
